import { styled, ButtonBase } from '@mui/material';

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  gap: theme.spacing(3),
  position: 'relative',
  '& .DCImgContainer': {
    width: '100%',
    borderRadius: theme.spacing(0.5),
    overflow: 'hidden',
    height: theme.typography.pxToRem(255),
    '&.DCLargeImage': {
      height: theme.typography.pxToRem(450),
    },
    '& .IBimg': {
      transition: 'transform 0.4s ease-in-out',
    },
  },
  '& .DCValueContainer': {
    position: 'absolute',
    top: theme.spacing(2),
    left: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.black,
    zIndex: 1,
    padding: theme.spacing(0.75, 1.25, 0.5, 1.25),
    borderRadius: theme.spacing(0.5),
  },
  '& .DCValue': {
    fontSize: theme.spacing(2.5),
    lineHeight: 'normal',
  },
  '& .DCOldValue': {
    marginLeft: theme.spacing(1),
    fontSize: theme.spacing(2),
    textDecoration: 'line-through',
  },
  '& .DCTageLine': {
    color: theme.palette.text.secondary,
  },
  '& .DCMaxText': {
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '& .DCVInfo': {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  '& .DCBtn': {
    paddingLeft: 0,
    paddingRight: 0,
    marginTop: 'auto',
    fontSize: theme.spacing(2),
    textTransform: 'none',
  },
  '&:hover': {
    '& .DCBtn': {
      color: theme.palette.primary.main,
    },
    '& .IBimg': {
      transform: 'scale(1.05)',
    },
  },
}));
export default StyledButtonBase;
